import {useEffect, useRef} from "react";
import {Button, Form, Input, Switch} from "antd";
import HospitalSelectBox from "../../../HospitalSelectBox";
import {t} from 'i18next'
import {v4} from "uuid";

const { TextArea } = Input;

export default function HL7ClientCreateEditModal({hospitalId, data, onSave}) {
    const formRef = useRef()

    useEffect(() => {
        if(data) {
            formRef.current.setFieldsValue({
                ...data,
                name: data?.appClient?.name,
                reportSuccessFieldsText: data?.reportSuccessFields?.join('\n') || ''
            })
        } else {
            const date = new Date();
            formRef.current.setFieldsValue({
                name: `hl7-client-${date.getTime()}`
            })
        }
    }, [data]);

    useEffect(() => {
        if(hospitalId) {
            formRef.current.setFieldsValue({
                hospitalId: hospitalId
            })
        }
    }, [hospitalId])

    const finish = async () => {
        const values = formRef.current.getFieldsValue();
        
        // Convert text to array (each line is one rule)
        const reportSuccessFieldsText = values.reportSuccessFieldsText || '';
        values.reportSuccessFields = reportSuccessFieldsText
            .split('\n')
            .map(line => line.trim())
            .filter(line => line.length > 0);
        
        delete values.reportSuccessFieldsText;
        
        onSave && onSave(values);
    }

    return (
        <>
            <Form
                layout={'vertical'}
                ref={formRef}
                onFinish={finish}
            >
                <Form.Item
                    label={t('Hospital')}
                    name={'hospitalId'}
                >
                    <HospitalSelectBox mode={'single'} disabled={true} />
                </Form.Item>

                <Form.Item
                    label={t('Name')}
                    name={'name'}
                >
                    <Input disabled={data} />
                </Form.Item>

                <Form.Item
                    label={t('Description')}
                    name={'description'}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Enabled')}
                    name={'enabled'}
                    valuePropName={'checked'}
                >
                    <Switch />
                </Form.Item>

                <Form.Item
                    label={t('Report Success Fields')}
                    name={'reportSuccessFieldsText'}
                    tooltip={t('Each line contains comma-separated tokens. If ALL tokens in a line are found in ACK response, report is marked as successful.')}
                >
                    <TextArea 
                        rows={4} 
                        placeholder="AA,rapor kaydedildi&#10;CA,zaten mevcut"
                    />
                </Form.Item>

                <Form.Item>
                    <Button htmlType={'submit'} type={'primary'}>
                        {t('Save')}
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}